import { ChimeAPI } from '../api/ChimeAPI';
import { Channel } from '../components/common/ChimeChatList';

export const getChannelWithLatestMessage = (
  channel: Channel,
  chimeApi: ChimeAPI
): Promise<Channel> => {
  return channel.LatestMessage
    ? new Promise((resolve) => resolve(channel))
    : chimeApi
        .listChannelMessages(channel.ChannelArn, null, null, 1)
        .then((msg) => msg?.Messages?.[0])
        .then((msg) => {
          return {
            content: msg?.Content,
            userId: msg?.Metadata.UserId,
            type: msg?.Metadata?.Type,
            isAutomated: !!msg?.Metadata?.AutomatedMsg,
            direction: msg?.Sender?.Arn === chimeApi.createMemberArn() ? 1 : 0
          };
        })
        .then(
          (msg) =>
            ({
              ...channel,
              LatestMessage: msg
            } as Channel)
        );
};
